import * as React from 'react';
import { Dispatch } from 'react-redux';
import { StoreState } from '../../../reducers';
import Accordion from '../../Accordion';
import { Translate } from 'react-redux-i18n';
import { ListDisplayType } from '../../../containers/DriveItemList/constants';
import { updateListDisplayType, resetFoldersDisplayType } from '../../../containers/DriveItemList/actions';
import Utils from '../../../utils';
import { InfosFields, CheckboxWrapper } from '../styles';

interface NavigationSelectorProps {
	displayType: ListDisplayType;
	dispatch: Dispatch<StoreState>;
}

interface NavigationSelectorState {
	shouldResetFoldersDisplayType: boolean;
}

class NavigationSelector extends React.Component<NavigationSelectorProps, NavigationSelectorState> {
	constructor(props: NavigationSelectorProps) {
		super(props);
		this.state = { shouldResetFoldersDisplayType: false };
		this.setDisplayType = this.setDisplayType.bind(this);
		this.toggleResetFoldersDisplayType = this.toggleResetFoldersDisplayType.bind(this);
	}

	setDisplayType(newType: ListDisplayType): void {
		const { dispatch } = this.props;
		const { shouldResetFoldersDisplayType } = this.state;

		dispatch(updateListDisplayType(newType));

		if (shouldResetFoldersDisplayType) {
			dispatch(resetFoldersDisplayType());
		}
	}

	toggleResetFoldersDisplayType(): void {
		this.setState({
			shouldResetFoldersDisplayType: !this.state.shouldResetFoldersDisplayType,
		});
	}

	renderDisplayTypesList() {
		const { displayType } = this.props;
		return Object.keys(ListDisplayType).map(type => (
			<InfosFields
				key={type}
				onClick={() => this.setDisplayType(type as ListDisplayType)}
				isActive={displayType === type}
			>
				<Translate value={`messages.${Utils.uncapitalize(type)}`} />
			</InfosFields>
		));
	}

	render() {
		const { displayType } = this.props;
		const { shouldResetFoldersDisplayType } = this.state;
		return (
			<Accordion
				title="messages.display_mode"
				selectedOption={`messages.${Utils.uncapitalize(displayType)}`}
				isOpened={false}
			>
				{this.renderDisplayTypesList()}
				<CheckboxWrapper>
					<label>
						<input
							type="checkbox"
							checked={shouldResetFoldersDisplayType}
							onChange={this.toggleResetFoldersDisplayType}
						/>
						{shouldResetFoldersDisplayType && Utils.getSvgIcon('iconset_check-1')}
						<Translate value="messages.reset_my_preferences" />
					</label>
				</CheckboxWrapper>
			</Accordion>
		);
	}
}

export default NavigationSelector;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ParametersPage/Navigation/index.tsx